// Reveal-on-scroll for the product timeline. Content is visible without JS; with reduced motion nothing moves.
(() => {
  const init = (root) => {
    if (root.dataset.cltlReady || !('IntersectionObserver' in window)) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    root.dataset.cltlReady = 'true';
    const targets = [...root.querySelectorAll('[data-cltl-reveal]')];
    const show = (target) => target.classList.add('is-in');
    const observer = new IntersectionObserver((entries) => entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      show(entry.target);
      observer.unobserve(entry.target);
    }), { threshold: 0.2 });
    targets.forEach((target) => observer.observe(target));
    root.classList.add('is-ready');
    // Safety net from the design: never leave content hidden if an observer callback is missed.
    const reveal = new IntersectionObserver(([entry]) => {
      if (!entry.isIntersecting) return;
      reveal.disconnect();
      window.setTimeout(() => targets.forEach(show), 2500);
    });
    reveal.observe(root);
  };
  const start = () => document.querySelectorAll('[data-cltl]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', start);
})();
